export default {"src":"/_next/static/media/galleries.8823510b.svg","height":77,"width":77,"blurWidth":0,"blurHeight":0};